import React from "react";
import { css } from "@emotion/react";
import classNames from 'classnames';

import Input from "core/Components/Form/Input";

type Props = {
    hasError?: boolean,
    label?: string,
    name: string,
    onChange?: any,
    value?: string,
    variant?: FormFieldVariant,
    className?: string,
};

const FormInput: React.FC<Props> = ({
    hasError,
    label,
    name,
    onChange,
    value,
    variant = 'text',
    className = '',
}) => {
    const style = css`
        width: 100%;
    `;

    return (
        <Input
            hasError={hasError}
            label={label}
            name={name}
            onChange={onChange}
            value={value}
            css={style}
            variant={variant}
            className={classNames("input-container", className)}
            hasBoxShadow
        />
    );
};

export default FormInput;
